import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import LinearProgressWithLabel from './LinearProgressWithLabel';
import musicPlayerStore from '../../stores/musicPlayer';

function BgPlayerLinearProgressWithLabel(props) {

  const currentBuffer = musicPlayerStore((state) => state.currentBuffer);
  const currentTime = musicPlayerStore((state) => state.currentTime);
  const currentTrack = musicPlayerStore((state) => state.currentTrack);

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const toMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  const currentProgress = () => {
    if (currentTrack && currentTrack.length) {
      return (currentTime / currentTrack.length.split(':').reduce((acc, time) => (60 * acc) + +time)) * 100;
    } else {
      return 0;
    }
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  //<LinearProgressWithLabel currentTime={toMMSS(currentTime)} buffer={currentBuffer * 100} value={currentProgress()} length={getLength(currentTrack)} onProgressClick={props.onProgressClick} />
  return (
    <LinearProgressWithLabel currentTime={toMMSS(currentTime)} buffer={currentBuffer * 100} value={currentProgress()} length={getLength(currentTrack)} onProgressClick={props.onProgressClick} />
  );
}

export default BgPlayerLinearProgressWithLabel;